import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace } from 'antd-mobile/lib';
import Util from '../../util.js';
import NavigatorMain from '../NavigatorMain';
import {
  clearJyOne,
  clearYlOne
} from '../../action/investmentAction';

import { hashHistory } from 'react-router';
import CacheHOC from "../HOC/StateCache.js";

// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';
const width = window.screen.width 

/*理财规划*/
class ChooseGh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingFlag:true,
    }
  }
  componentWillMount() {
  }
  handleCallback(){

  }
  componentDidMount(){
    let { dispatch } = this.props;
    document.title = '理财规划'
    document.body.scrollTo(0, 0);
  }
  componentWillUnmount() {
    
  }
  goBack(){
    hashHistory.goBack();
  }
  pushDetail(num){
    let pathname = "recoQuestionDoing";
    if(num == 1){
      let { dispatch } = this.props;
      hashHistory.push({
        pathname: "/educationCalculator",
        state: {
          school: "大学"
        }
      });
      dispatch(clearJyOne("大学"));
      return;
    }else if(num == 2){
      let { dispatch } = this.props;
      hashHistory.push({
        pathname: "/pensionCalculator"
      });
      dispatch(clearYlOne());
      return;
    }
    hashHistory.push({
      pathname: pathname
    })
  }
  render(){
    return(
      <div className="container">
        <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center', fontSize:"0.3rem" }}>理财规划 </div>
            <div style={{ WebkitFlex:1, textAlign:'right', fontSize:"0.28rem", paddingRight:'13px' }}></div>    
          </div>
        </NavigatorMain>
        <div className="content" id='ChooseGhIndex' style={{ background:"#FFF",display:'flex',flex:1,flexDirection:'column',overflowY:'scroll' }}>
          <div className="ChooseGh_top_bg">
            <div style={{ backgroundColor:'rgba(0,0,0,0)', color:'#FFF',fontSize:14,lineHeight:"22px" }}>
                当下有钱叫有财，未来一直有钱，才叫富。理财规划的意义就在于运用你现在既有的资源和可预期的资源进行长期的，规划性的，持续性的布局，实现终生的财务平衡
            </div>
          </div>
          <div style={{paddingTop:20, paddingBottom:15,paddingLeft:15 }}>
            <div style={{ color:'#4A4A4A', fontSize:14 }}>请选择您的理财规划目标：</div>
          </div>
          <div onClick={()=>{ this.pushDetail(1) } } className="ChooseGh_show_bannerbg" style={{width:width-30,height:(width-30)*(290/690), marginLeft:15 }}>
            <div style={{backgroundColor:'rgba(104,104,159,0.5)', height:65,paddingTop:10,paddingLeft:12,paddingRight:10 }}>
              <p style={{ fontSize:16, color:"#FFF",marginBottom:4 }}>教育理财规划</p>
              <p style={{ fontSize:13, color:"#FFF" }}>根据您对子女教育储备和目标，专属定制教育投资方案。</p>
            </div>
          </div>

          <div onClick={()=>{ this.pushDetail(2) } } className="ChooseGh_show_bannerbg ChooseGh_show_bannerbg2" style={{width:width-30,height:(width-30)*(290/690), marginLeft:15 }}>
            <div style={{backgroundColor:'rgba(104,104,159,0.5)', height:65,paddingTop:10,paddingLeft:12,paddingRight:10 }}>
              <p style={{ fontSize:16, color:"#FFF",marginBottom:4 }}>养老理财规划</p>
              <p style={{ fontSize:13, color:"#FFF" }}>根据您的养老储备和实际需求，专属定制养老投资方案。</p>
            </div>
          </div>

          <div onClick={()=>{ this.pushDetail(3) } } className="ChooseGh_show_bannerbg ChooseGh_show_bannerbg3" style={{width:width-30,height:(width-30)*(290/690), marginLeft:15 }}>
            <div style={{backgroundColor:'rgba(104,104,159,0.5)', height:65,paddingTop:10,paddingLeft:12,paddingRight:10 }}>
              <p style={{ fontSize:16, color:"#FFF",marginBottom:4 }}>资产增值</p>
              <p style={{ fontSize:13, color:"#FFF" }}>根据您的投资风险偏好特征，推荐适合您的基金组合。</p>
            </div>
          </div>

          <div>
            
          </div>

        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    
  }
}

export default connect(mapStateToProps)(CacheHOC(ChooseGh,'ChooseGhIndex'));


function getFx(fundtype){
  let touzFx = "";
  if(fundtype == "股票型" || fundtype == "指数型"){
    touzFx = "高"
  }else if(fundtype == "混合型" || fundtype == "债券型"){
    touzFx = "中"
  }else if(fundtype == "货币型" || fundtype == "理财型"){
    touzFx = "低"
  }
  return  touzFx;
}

/*根据对象参数按从小到大排序*/   
let compare = function (prop) {
    return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
        }
        if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }            
    } 
}




// WEBPACK FOOTER //
// ./src/components/fundDetail/ChooseGh.js